module.exports = __webpack_public_path__ + "static/media/step2_gif.6be82014.gif";